import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useAnalytics } from '@Shared/useAnalytics';

import Icon from '../Shared/Icons';

const LogoWrapper = styled.div`
  margin-right: 21px;
  height: 36px;
  max-width: 153px;
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoints.values.md}px) {
    margin-right: 61px;
  }
`;

const Logo = ({ isMobile, className }) => {
  const { trackEventAndGo } = useAnalytics();

  const trackLogoClick = ev => {
    trackEventAndGo(ev, 'clicked carvana logo', { platform: isMobile ? 'mobile' : 'desktop' });
  };

  return (
    <LogoWrapper className={className}>
      <a onClick={trackLogoClick} href="/" target="_self">
        <Icon iconName="carvanaLogo" />
      </a>
    </LogoWrapper>
  );
}

Logo.defaultProps = {
  className: '',
  isMobile: false,
};

Logo.propTypes = {
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default Logo;
